
import { mergeData } from 'vue-functional-data-merge'

import { ThemeMixin } from '../../mixins'

export default ThemeMixin.extend({
  name: 'WeveSheet',
  functional: true,
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
  render(h, { props, children, data, injections }) {
    return h(
      props.tag,
      mergeData(data, {
        staticClass: 'app-sheet',
        class: {
          'app-sheet--light': props.light,
          'w-theme--light': injections.theme === 'light',
          'w-theme--dark': injections.theme !== 'light',
        },
      }),
      children,
    )
  },
})
